var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartsBox"},_vm._l((_vm.pdata),function(item,index){return _c('div',{key:'a' + index,staticClass:"itemBox"},[_c('div',{staticClass:"left",attrs:{"title":item.name}},[_vm._v(" "+_vm._s(item.name)+" ")]),_c('div',{staticClass:"right"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }